import { Flex, Heading, Text } from '@chakra-ui/react';
import React from 'react';
import { useNavigate } from 'react-router';

import { ColorModeToggle } from '~/core/routes/dev/ColorModeToggle';
import { IconButtonV2 } from '~/packages/common-frontend/components/IconButton';
import { Icon } from '~/packages/common-frontend/components/icons';
import { PageHeader } from '~/packages/common-frontend/components/PageContainer';

// Fragments
type SectionHeaderProps = { children: React.ReactNode };
export const SectionHeader = ({ children }: SectionHeaderProps) => (
  <Heading
    as="h3"
    fontSize="1.25rem"
    fontWeight="semibold"
    fontFamily="monospace"
  >
    {children}
  </Heading>
);
type SectionTextProps = { children: React.ReactNode };
export const SectionText = ({ children }: SectionTextProps) => (
  <Text fontFamily="monospace">{children}</Text>
);

const BackButton = () => {
  const navigate = useNavigate();

  return (
    <IconButtonV2
      icon={<Icon icon="arrow-left" />}
      aria-label="Back"
      variant="primary-muted"
      colorScheme="v2-aurora"
      placement="bottom"
      onClick={() => navigate('/dev')}
    />
  );
};

// Exports
type Props = {
  title: React.ReactNode;
  children: React.ReactNode;
  FlexProps?: React.ComponentProps<typeof Flex>;
};
export const PageTemplate = ({ title, children, FlexProps }: Props) => {
  return (
    <Flex
      alignItems="stretch"
      direction="column"
      gap="2rem"
      flexGrow={1}
      padding="2rem"
      paddingBottom="5rem"
      {...FlexProps}
    >
      <PageHeader
        headerLabel={
          <Flex gap="0.5rem" alignItems="center">
            <BackButton />
            <ColorModeToggle />
            <span>{title}</span>
          </Flex>
        }
      />
      {children}
    </Flex>
  );
};
